const swiperProductMedia2 = new Swiper('.slider-mobile-gutter--custom', {
  loop: false,
  // Optional parameters
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
    breakpoints: {
      // when window width is >= 320px
      320: {
      slidesPerView: 1,
      spaceBetween: 20,
      slidesOffsetBefore: 0
      },
      // when window width is >= 480px
      480: {
      slidesPerView: 1,
      spaceBetween: 30,
      slidesOffsetBefore: 0
      },
      // when window width is >= 640px
      640: {
      slidesPerView: 3,
      spaceBetween: 40,
      slidesOffsetBefore: 0
      },
      1024: {
      slidesPerView: 6,
      spaceBetween: 10,
      slidesOffsetBefore: 0
      }
  }
});

const swiperProductMedia = new Swiper('.slider-container-main-product-swiper', {
  // Optional parameters
  direction: 'horizontal',
  autoHeight:true,
  navigation: {
    nextEl: ".slider-button--next",
    prevEl: ".slider-button--prev",
  },
  thumbs: {
   swiper: swiperProductMedia2
  },
  breakpoints: {
      // when window width is >= 320px
      320: {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0
      },
      // when window width is >= 480px
      480: {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0
      },
      // when window width is >= 640px
      640: {
      slidesPerView: 1,
      spaceBetween: 0,
      slidesOffsetBefore: 0
      }
  }
});


